<template>
    <div id="content-body">
        <div class="py-5 text-center w-100">
            <div class="mx-auto w-xxl w-auto-xs">
                <div class="px-3">
                    <div>
                        <h5>Forgot your password?</h5>
                        <p class="text-muted my-3">
                            Enter your email below and we will send you instructions on how to change your password.
                        </p>
                    </div>
                    <form  name="form" @submit.prevent="forgotPassword">
                        <div class="form-group">
                            <input type="email" placeholder="Email" class="form-control" v-model="form.email">
                        </div>
                        <button type="submit" class="btn primary btn-block p-x-md">Send</button>
                    </form>
                    <div class="py-4">
                        Return to
                        <router-link :to="{name : 'home'}" class="text-primary _600">
                          Sign in
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapGetters,mapState } from 'vuex';
import Api from '../../../service/api';
// import { setTimeout } from 'timers';

export default {
    components: {
    },
    data () {
        return {
            form: {
                email: ''
                
            }
        }
    },
    
    created() {
        
    },

    mounted() {
        
    },

   
    methods: {        
        forgotPassword(){
            return Api.forgotPassword(this.form)
            .then(response => {
                this.$swal({ title: response.data.message, type: "success" });
            })
            .catch(error => {
                //console.log(error);
                this.$swal({ title: error.response.data.message, type: "warning" });
            })
        }
    }
}
</script>

